import React, { Fragment } from 'react';
import { Form } from '../../../ui/universe';
import { Button } from 'tdesign-react';
import { OcrTable, DownloadExcel } from '../../../../utils/index.js';
import { EmptyCom } from '../components';

/**
 * Table 渲染器 - 表格识别结果
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {boolean} props.showDownload - 是否显示下载按钮
 */
const TableRenderer = ({ params, showDownload }) => {
  // 接口暂不支持日文无线表格识别，若传入日文无线表格，返回0
  // 0 为非表格文本，1 为有线表格，2 为无线表格
  // 表格头部是非表格type==0，主体是表格type==1

  if (params.TableDetections?.map((o) => o.Type).every((type) => type === 0)) {
    const cells = params.TableDetections?.map((item) => item.Cells).reduce((acc, curr) => {
      return acc.concat(curr);
    }, []);
    const arr = [];
    for (const v of cells) {
      arr.push(v.Text);
    }
    return arr;
  }

  const list = params.TableDetections?.filter((item) => [0, 1, 2].includes(item.Type)).sort((a, b) => a.Type - b.Type);
  const formList = list?.filter((item) => [0].includes(item.Type));
  const tableList = list?.filter((item) => [1, 2].includes(item.Type));

  if (list?.length <= 0) return <EmptyCom />;

  const handleDownload = () => {
    DownloadExcel(params.Data);
  };

  return (
    <>
      {/* formList */}
      {formList?.length > 0 && formList?.map((list_item, i) => (
        <Fragment key={`form-${i}`}>
          {list_item.Cells?.map((cell, ci) => (
            <Form.Item className="list" key={`cell-${ci}`} label="">
              {cell.Text}
            </Form.Item>
          ))}
        </Fragment>
      ))}

      {/* tableList */}
      {tableList?.length > 0 && tableList?.map((list_item, i) => {
        const tableData = OcrTable(list_item);
        return (
          <Fragment key={`table-${i}`}>
            {[1, 2].includes(list_item.Type) && (
              <p className="flex just-space-between align-center mtb-10">
                <Button variant="outline" theme="default">
                  <span>表格{i + 1}</span>
                </Button>
                {showDownload && (
                  <Button variant="text" theme="primary" onClick={handleDownload}>导出表格</Button>
                )}
              </p>
            )}
            <div className="unv-table__box__container">
              <table border="1" className="unv-table__box">
                {tableData.length > 0 && tableData?.map((tr, tri) => (
                  <tr key={`tr-${tri}`}>
                    {tr.length > 0 && tr?.map((td, tdi) => (
                      <td key={`td-${tdi}`} colSpan={td.occupyCol} rowSpan={td.occupyRow}>
                        {td.cell_content_text}
                      </td>
                    ))}
                  </tr>
                ))}
              </table>
            </div>
          </Fragment>
        );
      })}
    </>
  );
};

export default TableRenderer;
